import React from 'react'
import StockistReportHeader from "../stockist_report/StockistReportHeader";
import Sidebar from "../supervisor_home/sidebar/Sidebar";
import OtherSidebar from "../operator_home/sidebar/Sidebar";
import { ReactSession } from "react-client-session";
import Form from '../operator_home/Form';


function AddClaim() {
    const role = ReactSession.get("role");
return (
    <div className="claim__page">
        <StockistReportHeader />
        {role ==='2' ? <Sidebar /> : <OtherSidebar />}
        <Form />
    </div>
)
}

export default AddClaim